export const GET_SESSION = 'GET_SESSION';
export const SET_SESSION = 'SET_SESSION';
export const SET_MODULES = 'SET_MODULES';
